export default "__VITE_ASSET__BcYiZ1QK__"